module.exports = __webpack_public_path__ + "static/img/default.8d20ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/default.png
// module id = hNOw
// module chunks = 52